import { useCallback } from 'react'
import { useEarliestIncompletePeriod } from '../../hooks'
import { DateInput } from '../custom'

const PeriodDatePicker = props => {
  const period = useEarliestIncompletePeriod()

  const shouldDisableDate = useCallback(date => {
    return date.getDay() !== 6
  }, [])

  return (
    <DateInput
      disabled={!period}
      initialFocusedDate={period?.end_date}
      shouldDisableDate={shouldDisableDate}
      {...props}
    />
  )
}

export default PeriodDatePicker
